import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Banner, Process, Partners, Pricing, NewsletterSection, Mission } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Mission />
        <Services />
        <Counter />
        <Process />
        <Banner />
        <Pricing />
        <Testimonials />
        <Team />
        <NewsletterSection />
        <Partners />

      </section>

    </>
  );
}

export default AboutUs;